import { useEffect, useState } from 'react'

export function useScrollPercentage(
    el?: null | Element,
    options?: {
        scrollPercentageThreshold: number
        onThresholdReached: VoidFunction
    }
) {
    const [scrollPercentage, setScrollPercentage] = useState(0)

    useEffect(() => {
        const element = el ?? document.body
        if (!element) {
            return
        }

        const handleScroll = () => {
            const scrollPosition = element.scrollTop
            const scrollHeight = element.scrollHeight
            const clientHeight = element.clientHeight
            const percentage = (scrollPosition / (scrollHeight - clientHeight)) * 100
            setScrollPercentage(percentage)

            if (options) {
                if (percentage >= options.scrollPercentageThreshold) {
                    options.onThresholdReached()
                }
            }
        }

        element.addEventListener('scroll', handleScroll)
        return () => element.removeEventListener('scroll', handleScroll)
    }, [el])

    return { scrollPercentage }
}
